export default __webpack_public_path__ + "static/media/wifi.fb6fed16.svg";